<template>
  <div>
    <choose-cert v-if="applyVo && step === 'chooseCert'" :apply-vo="applyVo" @submit="submitSelectedCert"
                 :disabled.sync="disabled"></choose-cert>
    <cert-package v-if="applyVo && step === 'confirmPackInfo'" :apply-vo="applyVo" @changeStep="changeStep"
                  @submit="submitPackage" :disabled.sync="disabled"></cert-package>
  </div>
</template>

<script>
import { confirmPack, find } from '@/api/apply'
import ChooseCert from '@/views/apply/confirmPack/component/chooseCert'
import { listCert } from '@/api/base'
import CertPackage from '@/views/apply/confirmPack/component/certPackage'
import { mapGetters } from 'vuex'

export default {
  name: 'confirmPack',
  components: { CertPackage, ChooseCert },
  data () {
    return {
      applyVo: null,
      step: 'chooseCert',
      disabled: false
    }
  },
  computed: {
    ...mapGetters([
      'currentApplyId'
    ])
  },
  mounted () {
    this.loadApply(this.currentApplyId)
  },
  methods: {
    loadApply (id) {
      find({
        id: id
      }).then(res => {
        this.applyVo = res.data
        if (this.applyVo.applyStatus === 'CANCELLED') {
          this.$message.info(this.$t('lang.toast.applyAlreadyCancelled'))
          this.$store.dispatch('removeCurrentApplyId')
          this.$router.push('confirmInfo')
        } else if (this.applyVo.applyStatus !== 'DRAFT') {
          this.$confirm(this.$t('lang.toast.applyAlreadySubmit'), this.$t('lang.common.warning'), {
            type: 'warning',
            confirmButtonClass: 'el-button--ceibsprimary',
            cancelButtonClass: 'el-button--ceibs'
          }).then(() => {
            this.$store.dispatch('removeCurrentApplyId')
            this.$router.push('confirmInfo')
          })
          this.disabled = true
        }
        if (this.applyVo.applyType === 'PAPER' && this.applyVo.packVoList && this.applyVo.packVoList.length > 0) {
          listCert({
            courseId: this.applyVo.courseId
          }).then(certRes => {
            const certList = certRes.data
            this.applyVo.packVoList.forEach(pack => {
              pack.selectedCertList = []
              pack.detailVoList.forEach(detail => {
                // 找到对应cert
                const cert = certList.filter(cert => cert.id === detail.certId)[0]
                if (cert) {
                  const newCert = JSON.parse(JSON.stringify(cert))
                  newCert.copyNumber = detail.copyNumber
                  newCert.uploadedAttachment = detail.userUploadAttachments
                  pack.selectedCertList.push(newCert)
                }
              })
            })
            this.$set(this.applyVo, 'tempPackVoList', this.applyVo.packVoList)
            this.step = 'confirmPackInfo'
          })
        }
      })
    },
    submitSelectedCert (selectedCert, needElectronicVersion) {
      this.applyVo.needElectronicVersion = needElectronicVersion ? 'Y' : 'N'
      if (this.applyVo.applyType === 'PAPER') {
        this.$set(this.applyVo, 'tempPackVoList', [])
        this.applyVo.tempPackVoList.push({
          packageType: 'NORMAL',
          packageNo: 1,
          selectedCertList: selectedCert
        })
        this.step = 'confirmPackInfo'
      } else {
        this.applyVo.needExpedite = 'N'
        this.submitPackage([{
          packageType: 'NORMAL',
          packageNo: 1,
          selectedCertList: selectedCert
        }])
      }
    },
    changeStep (stepName) {
      this.step = stepName
    },
    submitPackage (packList) {
      this.applyVo.packVoList = packList
      confirmPack(this.applyVo).then(res => {
        this.applyVo = res.data
        if (this.applyVo.applyType === 'PAPER') {
          // 跳转到选择领取方式
          this.$router.push('confirmReceiveInfo')
        } else {
          // 跳转到计费详情
          this.$router.push('submit')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
